import styled from "styled-components";

export const HeatmapChartContainer = styled.div`
  .data-cell {
    rx: 2;
    width: 9px;
    height: 9px;
  }
  .white-cell {
    fill: #b8b9bd;
  }
  .red-cell {
    fill: #ff3f3f;
  }
  .green-cell {
    fill: #25ff7c;
  }
  .gray-cell {
    fill: gray;
  }
  .react-calendar-heatmap text {
    font-size: 6px;
    fill: #aaa;
  }
  .react-calendar-heatmap {
    border: 1px solid #e2e4e8;
    padding-right: 15px;
    border-radius: 10px;
    padding-top: 15px;
    margin: 20px 30px;
  }

  @media (max-width: 768px) {
    overflow-x: scroll;

    .chart-wrapper {
      width: 800px;
    }

    .react-calendar-heatmap {
      padding-top: 10px;
      margin: 0;
    }
  }
`;
